import * as z from "zod";
import { Icon } from "./Icon";
import { TranslatedText } from "./TranslatedText";
export const Header = z.object({
    type: z.literal("header"),
    value: z.object({
        startIcon: Icon.optional(),
        text: TranslatedText,
    }),
});
